import Routers from './router'
import loginStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('loginModule', loginStore)
	}
}